type RemainingTime = {
	minutes: string
	seconds: string
}

export const getTimeRemaining = (timestampString: string, waitTimeInMillis: number): RemainingTime | null => {
	const timestamp = new Date(timestampString).getTime() // Convert timestamp string to milliseconds
	const currentTime = Date.now() // Current time in milliseconds

	const timeElapsed = currentTime - timestamp
	const timeRemaining = waitTimeInMillis - timeElapsed

	if (timeRemaining <= 0) {
		return null
	} else {
		const minutes = `${Math.floor(timeRemaining / 60000)}`
		const unformattedSeconds = Math.floor((timeRemaining % 60000) / 1000)
		const seconds = unformattedSeconds < 10 ? `0${unformattedSeconds}` : `${unformattedSeconds}`
		return { minutes, seconds }
	}
}
